import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Row, Col } from 'react-bootstrap';
import 'react-day-picker/lib/style.css';

import { Center, Black } from '../../../GeneralStyle'
import moment from 'moment'
import { SubHeading, LogeButtonSlim } from '../ActiveResidenceBookingsStyle';

@inject('residenceBookingStore')

@observer
class ConfirmBooking extends Component {

  createBooking() {
    this.props.residenceBookingStore.setScreenNumber(3)
    this.props.residenceBookingStore.createBooking()
  }

  render() {
    const {
      // bookingDate,
      arrivalTime,
      arrivalDate,
      depatureDate,
    } = this.props.residenceBookingStore

    // const isSameMonth = moment(bookingDate).isSame(moment(bookingDate).add(7, 'days'), 'month');

    return (
      <div style={{ paddingTop: 35, paddingBottom: 35 }}>
        <Row style={{ paddingBottom: 25 }}>
          <Col smOffset={1} sm={6}>
            <SubHeading>IHRE AN- & ABREISE</SubHeading>
            <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>
            <Black style={{ paddingTop: 10, paddingLeft: 15 }}>
              Ankunft am <strong>{moment(arrivalDate).locale('de').format('LL')}</strong>, geplant um <strong>{arrivalTime} Uhr</strong>.<br />
            </Black>
            <Black style={{ paddingTop: 5, paddingLeft: 15 }}>
              Abreise am <strong>{moment(depatureDate).locale('de').format('LL')}</strong>, checkout bis <strong>10 Uhr</strong>.
            </Black>
          </Col>
          <Col sm={10} md={10} lg={5}>
            <SubHeading>WO?</SubHeading>
            <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 20 }}></div>
            <Black style={{ paddingTop: 5, marginLeft: 15 }}>Azahara II, Apto 1B, <br />Avenida de Golf,<br /> Nueva Andalucia 29660</Black>
          </Col>
        </Row>

        <Center marginTop={30} marginBottom={30}>

          <LogeButtonSlim
            hoverFontColor={"white"}
            onClick={() => this.createBooking()}>
            Buchung abschließen</LogeButtonSlim>

        </Center>
      </div>
    );
  }
}

ConfirmBooking.propTypes = {
  residenceBookingStore: MobxPropTypes.observableObject,
};

export default ConfirmBooking;



// WEBPACK FOOTER //
// /src/components/internal/Residence/ResidenceBookingModal/ResidenceConfirmBooking.js